import { Box } from "@mui/material";
import React from "react";
import HeaderLogo from "../ProtectRoute/LoginScreen/HeaderLogo";
import HamburgerButton from "./HamburgerButton.tsx";

export default function HeaderWithMenu() {
  return (
    <Box
      display="flex"
      maxWidth="460px"
      width="100%"
      mx="auto"
      justifyContent="space-between"
      alignItems="center"
      sx={{ position: "relative" }}
    >
      <HeaderLogo />
      <HamburgerButton />
    </Box>
  );
}
